<template>
  <div>
    <div style="position:relative;">
      <div class="homepage-show_content">
        <no-ssr>
          <swiper :options="swiperOption">
            <swiper-slide v-for="(item, index) in imageList" :key="index">
              <div
                @click="openImagePreview(index)"
                class="homepage-show_img_body"
              >
                <img
                  :src="item"
                  style="width:100%; height:100%;object-fit:cover "
                />
              </div>
            </swiper-slide>
            <div
              slot="button-prev"
              v-show="show"
              class="swiper-button-prev swiper-button-black"
            ></div>
            <div
              slot="button-next"
              v-show="show"
              class="swiper-button-next swiper-button-black"
            ></div>
          </swiper>
        </no-ssr>
      </div>
    </div>

    <div
      v-show="showImagePreview"
      @click="closeImagePreview()"
      class="close_button hide_on_mobile"
    >
      <i class="el-icon-circle-close"></i>
    </div>
    <van-image-preview
      v-model="showImagePreview"
      :start-position="position"
      :images="imageList"
    ></van-image-preview>
  </div>
</template>
<script>
export default {
  props: {
    imageList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      position: 0,
      showImagePreview: false,
      isBigScreen: true,
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 3,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
    show() {
      return this.imageList.length > 4
    }
  },
  created() {
    if (this.$_thebox.clientWidth > 1250) {
      this.isBigScreen = true
      this.swiperOption.slidesPerView = 4
      this.swiperOption.spaceBetween = 15
    } else if (
      this.$_thebox.clientWidth <= 1250 &&
      this.$_thebox.clientWidth > 940
    ) {
      this.isBigScreen = true
      this.swiperOption.slidesPerView = 3
      this.swiperOption.spaceBetween = 15
    } else {
      this.isBigScreen = false
      this.swiperOption.slidesPerView = 3
      this.swiperOption.spaceBetween = 15
    }
  },
  methods: {
    openImagePreview(index) {
      this.position = index
      this.showImagePreview = true
    },
    closeImagePreview() {
      this.showImagePreview = false
    }
  }
}
</script>
<style scoped>
.swiper-container {
  position: inherit;
}
.close_button {
  cursor: pointer;
  width: 40px;
  height: 40px;
  color: white;
  font-size: 40px;
  position: fixed;
  top: 20px;
  opacity: 0.8;
  right: 20px;
  z-index: 2200;
}

.close_button:hover {
  opacity: 1;
}
</style>
<style lang="scss">
.homepage-show_content {
  width: calc(100% - 80px);
  margin: 0 auto;
}
.homepage-show_img_body {
  cursor: pointer;
  width: 177px;
  height: 138px;
}
.swiper-button-prev {
  left: 0px !important;
}
.swiper-button-next {
  right: 0px !important;
}

@media screen and(max-width:940px) {
  .homepage-show_content {
    width: 100%;
  }
  .homepage-show_img_body {
    width: 118px;
    height: 91px;
  }
  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }
}
</style>
